module.exports = __webpack_public_path__ + "static/aktive_fortbewegung-0f3effe0f4eca46ca1dcdb8db85a771e.png";